module.exports = __webpack_public_path__ + "ae3dc84359d5ef440a39231dbeeec698.png";